import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/faqs";

export default function Faq() {
  useEffect(() => { document.title = "Sıkça Sorulan Sorular | VoyaCar Rental"; }, []);
  return (
    <div>
      <div className="bg-[#171717] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl sm:text-4xl font-bold">Sıkça Sorulan Sorular</h1>
          <p className="mt-2 text-neutral-300">Merak ettiğiniz her şeyin yanıtı burada.</p>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-[#171717] font-medium hover:text-[#A11016]">{f.q}</AccordionTrigger>
              <AccordionContent className="text-neutral-600 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
